import { render, staticRenderFns } from "./review-dialog.pug?vue&type=template&id=610662ae&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./review-dialog.scss?vue&type=style&index=0&id=610662ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610662ae",
  null
  
)

export default component.exports